import _ from 'lodash'
import {
  getCategory,
  getCountry,
  getMaterialOptions,
  getRegion
} from '@/api/options'
import {
  fetchTemplateSetting
} from '@/api/vmaker/template'
import { searchUserList } from '@/api/system/user'
import { fetchAppCategoryList } from '@/api/system/app_category'
import { fetchAdvertiserList } from '@/api/advertiser/manage'
import { getPmTeams } from '@/api/creative/review'

// 存储角色常量，所有角色默认一次性请求1000条数据。
const ROLE_REQ_NUM = 1000
const options = {
  state: {
    category: [],
    country: [],
    materialOptions: {},
    languages: [],
    region: [],
    designer: [],
    demander: [],
    appCategory: [],
    advertisers: [],
    developer: [],
    vmakerSetting: [],
    tester: [],
    pmTeams: [],
    accountMgr: [],
    fontList: [],
    planner: []
  },

  mutations: {
    SET_VMAKERSETTING: (state, options) => {
      state.vmakerSetting = options || {}
    },
    SET_CATEGORY: (state, category) => {
      state.category = category
    },
    SET_COUNTRY: (state, country) => {
      state.country = country
    },
    SET_OPTIONS: (state, options) => {
      state.materialOptions = options
    },
    SET_REGION: (state, options) => {
      state.region = options
    },
    SET_DESIGNER: (state, options) => {
      state.designer = options || []
    },
    SET_DEMANDER: (state, options) => {
      state.demander = options || []
    },
    SET_ACCOUNTMGR: (state, options) => {
      state.accountMgr = options || []
    },
    SET_DEVELOPER: (state, options) => {
      state.developer = options || []
    },
    SET_TESTER: (state, options) => {
      state.tester = options || []
    },
    SET_APP_CATEGORY: (state, category) => {
      state.appCategory = category
    },
    SET_ADVERTISERS: (state, advertisers) => {
      state.advertisers = advertisers
    },
    SET_PM_TEAMS: (state, teams) => {
      state.pmTeams = teams
    },
    SET_PLANNER: (state, value) => {
      state.planner = value
    }
  },

  actions: {
    // 获取类别
    GetCategory({ commit }) {
      return new Promise((resolve, reject) => {
        getCategory()
          .then(response => {
            const data = response.data.data.list
            commit('SET_CATEGORY', data)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取国家
    GetCountry({ commit }) {
      return new Promise((resolve, reject) => {
        getCountry()
          .then(response => {
            const data = response.data.data.list
            commit('SET_COUNTRY', data)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    GetMaterialOptions({ commit }) {
      return new Promise((resolve, reject) => {
        getMaterialOptions()
          .then(response => {
            const data = response.data.data
            commit('SET_OPTIONS', data)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    GetVmakerSetting({ commit }) {
      return new Promise((resolve, reject) => {
        fetchTemplateSetting()
          .then(response => {
            const data = response.data.data
            commit('SET_VMAKERSETTING', data)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    GetRegion({ commit }) {
      return new Promise((resolve, reject) => {
        getRegion()
          .then(response => {
            const data = response.data.data.region_list
            commit('SET_REGION', data)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取设计师
    GetDesigner({ commit }) {
      return new Promise((resolve, reject) => {
        searchUserList({
          page_size: ROLE_REQ_NUM,
          role_type: 1,
          page: 1
        })
          .then(response => {
            commit('SET_DESIGNER', response.data.data.list)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取提需师
    GetDemander({ commit }) {
      return new Promise((resolve, reject) => {
        searchUserList({
          page_size: ROLE_REQ_NUM,
          role_type: 8,
          page: 1
        })
          .then(response => {
            commit('SET_DEMANDER', response.data.data.list)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取提需师
    GetAccountMgr({ commit }) {
      return new Promise((resolve, reject) => {
        searchUserList({
          page_size: ROLE_REQ_NUM,
          role_type: 4,
          page: 1
        })
          .then(response => {
            commit('SET_ACCOUNTMGR', response.data.data.list)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取开发者
    GetDeveloper({ commit }) {
      return new Promise((resolve, reject) => {
        searchUserList({
          page_size: ROLE_REQ_NUM,
          role_type: 2,
          page: 1
        })
          .then(response => {
            commit('SET_DEVELOPER', response.data.data.list)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取测试
    GetTester({ commit }) {
      return new Promise((resolve, reject) => {
        searchUserList({
          page_size: ROLE_REQ_NUM,
          role_type: 3,
          page: 1
        })
          .then(response => {
            commit('SET_TESTER', response.data.data.list)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取app category
    GetAppCategoryList({ commit }) {
      return new Promise((resolve, reject) => {
        fetchAppCategoryList()
          .then(response => {
            commit('SET_APP_CATEGORY', response.data.data.list)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    GetAdvertisers({ commit }) {
      return new Promise((resolve, reject) => {
        fetchAdvertiserList({ page: 1, page_size: ROLE_REQ_NUM })
          .then(res => {
            commit('SET_ADVERTISERS', _.get(res, 'data.data.list') || [])
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取 PM 团队列表
    GetPmTeams({ commit }) {
      return new Promise((resolve, reject) => {
        getPmTeams()
          .then(res => {
            let teams = _.get(res, 'data.data.teams') || []
            teams = teams.map(teamItem => {
              return {
                value: teamItem.name,
                label: teamItem.alias
              }
            })
            teams.unshift({ value: '', label: 'All' })
            commit('SET_PM_TEAMS', teams)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取策划师
    GetPlanner({ commit }) {
      return new Promise((resolve, reject) => {
        searchUserList({
          page_size: ROLE_REQ_NUM, // 内部系统，角色人数不会超过1000
          role_type: 9, // 策划师的role_type为9
          page: 1
        }).then(response => {
          commit('SET_PLANNER', _.get(response, 'data.data.list'))
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default options
